export function customSelect() {
    if ($("select").length) {
        jcf.setOptions("Select", {
            wrapNative: false,
            flipDropToFit: false,
            fakeDropInBody: false,
            maxVisibleItems: 6,
            useCustomScroll: false
        });

        jcf.replaceAll();
    }

    if ($(".jcf-scrollable").length) {
        jcf.replaceAll();
    }

    $(window).on("resize", function () {
        setTimeout(function () {
            jcf.destroyAll();
            jcf.replaceAll();
        }, 300)
    })
}



// WEBPACK FOOTER //
// ./assets/js/modules/custom-select.js